const task = {
    state: {
        level: null,
        orgId: null,
        mapHeadIndex: null,
        mapHeadId: null,
        mapId: null
    },
    mutations: {
        SET_LEVEL: (state, level) => {
            state.level = level;
        },
        SET_ORGID: (state, orgId) => {
            state.orgId = orgId;
        },
        SET_MAP_INDEX: (state, index) => {
            state.mapHeadIndex = index;
        },
        SET_MAP_HEAD_ID: (state, id) => {
            state.mapHeadId = id;
        },
        SET_MAP_ID: (state, id) => {
            state.mapId = id;
        }
    },
    actions: {
        // 获取用户信息
        setLevel({ commit, dispatch }, level) {
            commit('SET_LEVEL', level);
        },
        setOrgId({ commit, dispatch }, orgId) {
            commit('SET_ORGID', orgId);
        },
        setMapIndex({ commit, dispatch }, index) {
            commit('SET_MAP_INDEX', index);
        },
        setMapHeadId({ commit, dispatch }, id) {
            commit('SET_MAP_HEAD_ID', id);
        },
        setMapId({ commit, dispatch }, id) {
            console.log('SET_MAP_ID', id);
            commit('SET_MAP_ID', id);
        }
    }
};

export default task;
